<div id="recent-events" class="inner-page events-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Recent Events</h2>
    <p class="inner-lead mt-3">
      Stay updated with the latest happenings, celebrations, and academic events at Shah Satnam Ji Girls' College, Sirsa.
    </p>

    <hr class="divider">

    <div class="events-body mt-4">
      <!-- Tab Bar -->
      <div class="events__tabs">
          <button class="events__tab" [class.events__tab--active]="activeTab === 'happening'"
              (click)="setTab('happening')">
              <i class="fas fa-bolt"></i>
              <span>Happening</span>
              <span class="events__tab-count">{{ totalHappeningCount }}</span>
          </button>
          <button class="events__tab" [class.events__tab--active]="activeTab === 'upcoming'"
              (click)="setTab('upcoming')">
              <i class="fas fa-calendar-alt"></i>
              <span>Upcoming</span>
              <span class="events__tab-count">{{ totalUpcomingCount }}</span>
          </button>
          <button class="events__tab" [class.events__tab--active]="activeTab === 'expired'"
              (click)="setTab('expired')">
              <i class="fas fa-history"></i>
              <span>Expired</span>
              <span class="events__tab-count">{{ totalExpiredCount }}</span>
          </button>
      </div>

      <!-- Section Label -->
      <div class="events__section-label mt-4">
          <span class="events__section-dot"
              [class.events__section-dot--happening]="activeTab === 'happening'"
              [class.events__section-dot--upcoming]="activeTab === 'upcoming'"
              [class.events__section-dot--expired]="activeTab === 'expired'"></span>
          <span *ngIf="activeTab === 'happening'">Currently Happening</span>
          <span *ngIf="activeTab === 'upcoming'">Coming Soon</span>
          <span *ngIf="activeTab === 'expired'">Past Events</span>
      </div>

      <!-- Empty State -->
      <div class="events__empty" *ngIf="currentEvents.length === 0">
          <i class="fas fa-calendar-times"></i>
          <p>No events in this category right now.</p>
      </div>

      <!-- Event Cards -->
      <div class="events__list mt-3">
          <div class="events__card events__card--clickable" *ngFor="let event of currentEvents; let i = index"
              [class.events__card--expired]="activeTab === 'expired'"
              (click)="openEventModal(event)">

              <!-- Date Badge -->
              <div class="events__date-badge"
                  [class.events__date-badge--happening]="activeTab === 'happening'"
                  [class.events__date-badge--upcoming]="activeTab === 'upcoming'"
                  [class.events__date-badge--expired]="activeTab === 'expired'">
                  <span class="events__date-day">{{ event.day }}</span>
                  <span class="events__date-month">{{ event.month }}</span>
              </div>

              <!-- Event Content -->
              <div class="events__card-body">
                  <h5 class="events__card-title">{{ event.title }}</h5>
                  <div class="events__card-meta">
                      <span class="events__meta-item" *ngIf="event.time">
                          <i class="far fa-clock"></i> {{ event.time }}
                      </span>
                      <span class="events__meta-divider" *ngIf="event.time"></span>
                      <span class="events__meta-item">
                          <i class="fas fa-map-marker-alt"></i> {{ event.location }}
                      </span>
                  </div>
                  <p class="events__card-desc">{{ event.description }}</p>

                  <!-- Event Attachments Actions -->
                  <div class="events__card-actions" *ngIf="event.imageUrl || event.pdfUrl">
                      <a *ngIf="event.imageUrl" [href]="event.imageUrl" target="_blank" class="btn-event-action" (click)="$event.stopPropagation()">
                          <i class="far fa-image text-success"></i> View Image
                      </a>
                      <a *ngIf="event.pdfUrl" [href]="event.pdfUrl" target="_blank" class="btn-event-action" (click)="$event.stopPropagation()">
                          <i class="far fa-file-pdf text-danger"></i> View PDF
                      </a>
                  </div>
              </div>

              <!-- Status Indicator -->
              <div class="events__status-pip"
                  [class.events__status-pip--happening]="activeTab === 'happening'"
                  [class.events__status-pip--upcoming]="activeTab === 'upcoming'"
                  [class.events__status-pip--expired]="activeTab === 'expired'">
              </div>
          </div>
      </div>
    </div>
  </div>
</div>

<!-- Event Detail Modal -->
<div class="event-modal-backdrop" *ngIf="selectedEvent" (click)="closeEventModal()">
    <div class="event-modal-content" (click)="$event.stopPropagation()">
        <!-- Close Button -->
        <button class="event-modal-close" (click)="closeEventModal()">
            <i class="fas fa-times"></i>
        </button>
        
        <div class="event-modal-header">
            <div class="event-modal-date"
                [class.event-modal-date--happening]="activeTab === 'happening'"
                [class.event-modal-date--upcoming]="activeTab === 'upcoming'"
                [class.event-modal-date--expired]="activeTab === 'expired'">
                <span class="event-modal-day">{{ selectedEvent.day }}</span>
                <span class="event-modal-month">{{ selectedEvent.month }}</span>
            </div>
            <div class="event-modal-title-group">
                <h3 class="event-modal-title">{{ selectedEvent.title }}</h3>
                <div class="event-modal-meta">
                    <span class="event-modal-meta-item" *ngIf="selectedEvent.time">
                        <i class="far fa-clock"></i> {{ selectedEvent.time }}
                    </span>
                    <span class="event-modal-meta-divider" *ngIf="selectedEvent.time"></span>
                    <span class="event-modal-meta-item">
                        <i class="fas fa-map-marker-alt"></i> {{ selectedEvent.location }}
                    </span>
                </div>
            </div>
        </div>
        
        <div class="event-modal-body">
            <!-- Description -->
            <p class="event-modal-desc">{{ selectedEvent.description }}</p>
            
            <!-- Image Section -->
            <div class="event-modal-image-wrapper" *ngIf="selectedEvent.imageUrl">
                <img [src]="selectedEvent.imageUrl" alt="Event Image" class="event-modal-image">
            </div>
        </div>
        
        <div class="event-modal-footer" *ngIf="selectedEvent.pdfUrl || selectedEvent.imageUrl">
            <a *ngIf="selectedEvent.imageUrl" [href]="selectedEvent.imageUrl" target="_blank" class="btn-event-action">
                <i class="far fa-image text-success"></i> Open Image in New Tab
            </a>
            <a *ngIf="selectedEvent.pdfUrl" [href]="selectedEvent.pdfUrl" target="_blank" class="btn-event-action">
                <i class="far fa-file-pdf text-danger"></i> Open PDF in New Tab
            </a>
        </div>
    </div>
</div>
